import React from 'react'
import { TableIncrementalStep } from '../../../../../components/common/table'

const FoilingOperationCostTable = ({
  data = {},
  onChange,
}) => {
  const handleOnSubmitEditRow = (key, value) => {
    const tmp = [...data.dataFoilingOperationCosts]
    tmp[key] = value
    onChange({ ...data, dataFoilingOperationCosts: tmp })
  }

  const handleOnSubmitEditColumn = (value, rows) => {
    onChange({ ...data, headerFoilingOperationCosts: value, dataFoilingOperationCosts: rows })
  }

  const handleOnSubmitNewColumn = (value, index) => {
    const tmpHeaders = [...data.headerFoilingOperationCosts].map((column, i) => {
      let colDataIndex
      if (/column*/.test(column.dataIndex)) {
        colDataIndex = `column${i}`
      } else {
        colDataIndex = column.dataIndex
      }
      return {
        ...column,
        dataIndex: colDataIndex,
        key: colDataIndex,
      }
    })
    const tmpDatas = [...data.dataFoilingOperationCosts].map((row, i) => ({
      ...row,
      [index]: 0,
    }))
    tmpHeaders.push({
      title: value,
      dataIndex: index,
      key: index,
      inputType: 'number',
      editable: true,
      editColumn: true,
      alignCell: 'center',
    })
    onChange({ ...data, headerFoilingOperationCosts: tmpHeaders, dataFoilingOperationCosts: tmpDatas })
  }

  return (
    <TableIncrementalStep
      title="ต้นทุนการปั๊มฟอยล์-ทองเค (Foil Operation Costs)"
      onSubmitEditRow={handleOnSubmitEditRow}
      onSubmitEditColumn={handleOnSubmitEditColumn}
      onSubmitNewColumn={handleOnSubmitNewColumn}
      headers={data.headerFoilingOperationCosts}
      data={data.dataFoilingOperationCosts}
      unit={'บาท'}
    />
  )
}

export default FoilingOperationCostTable
